import { ErrorService } from "services/error-service";
import { Router } from "aurelia-router";
import { Models } from "models/core";
import { OfferStatusService } from "services/offer-status-service";
import { autoinject } from "aurelia-framework";
import { ToastService } from "services/toast-service";
import { EventAggregator } from "aurelia-event-aggregator";

@autoinject
export class OfferStatusNew {
  private offerstatus: Models.OfferStatus = new Models.OfferStatus();

  constructor(
    private offerStatusService: OfferStatusService, 
    private router: Router,
    private toastService: ToastService,
    private errorService: ErrorService,
    private eventAggregator: EventAggregator
  ) {}

  createOfferStatus() {
    this.offerStatusService
      .post(this.offerstatus)
      .then(res => {
        this.eventAggregator.publish("offerStatusListReset", 1);
        this.toastService.showSuccess("offerstatus.created");
        this.router.navigateToRoute("offer-status-detail", { Id: res.Id });
      })
      .catch(err => this.errorService.handleError(err));
  }
}
